/**
 * @generated SignedSource<<428eab9e874e65cdadb572c2f27e118c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceOriginalImage_sheet$data = {
  readonly id: string;
  readonly download_url: string;
  readonly " $fragmentType": "PieceOriginalImage_sheet";
};
export type PieceOriginalImage_sheet$key = {
  readonly " $data"?: PieceOriginalImage_sheet$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceOriginalImage_sheet">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceOriginalImage_sheet",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "download_url",
      "storageKey": null
    }
  ],
  "type": "MusicSheet",
  "abstractKey": null
};

(node as any).hash = "870bd8a36067be952e4a5f3f118721f3";

export default node;
